import WheelBonusRecord from "integration/records/wheel-bonus-record";
import WheelBonusResult from "integration/results/wheel-bonus-result";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import translations from "slotworks/i18n/translations";
import gameState from "slotworks/model/game-state";
import soundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";

export default class WheelTurnsTransitions extends AbstractSceneTransition {
    
    public in(): Contract<void> {
        return new Contract((resolve) => {
            let count = 0;
            const record = gameState.getCurrentGame().getCurrentRecord();
            if (record instanceof WheelBonusRecord) {
                count = record.total;
            } else {
                const results = record.getResultsOfType(WheelBonusResult);
                if (results.length) {
                    const result = results[0] as WheelBonusResult;
                    count = result.total;
                }
            }

            const fs = Layers.Custom.get("Transition").getSpine("fs");

            if (count >= 3) {
                fs.play(0, "3turns", false);
            } else {
                fs.play(0, count === 1 ? "1turn" : "2turns", false);
            }
            
            const text = Layers.Custom.get("Transition").getText("turns_text");
            if (count > 1) {
                try {
                    text.text = translations.get(`bonuswheel_intro_${count}_turns`);
                    text.updateText(true);

                    // @ts-ignore
                    fs.hackTextureBySlotName("A/placeholder_text_turns", text.texture, { width: text.width, height: text.height });

                    text.visible = false;
                } catch (e) {
                    text.visible = false;
                }
            } else {
                text.visible = false;
            }

            setTimeout(() => soundManager.customEvent("plaque_exit"), 1800);
            fs.state.tracks[0].listener = {
                complete: (trackEntry) => {
                    fs.state.tracks[0].listener = null;
                    resolve(null);
                }
            }
        });
    }
}
        